import React from 'react'
import { connect } from 'react-redux'
import { Field, formValueSelector } from 'redux-form'
import LogsListing from '../../../../../../../../../itrust_common/components/others/listings/LogsListing'
import SpecteraFormButton from '../../../spectera/claimForm/SpecteraFormButton'
import { Checkbox } from '../../../../../../../../../itrust_common/components/form'

const selector = formValueSelector('VersantClaimForm')

const COMPATIBLE = {
  Exam: ['Exam', 'Frames', 'Contact Lens', 'Spectacle Lens', 'Contact Lens Fit & F/U'],
  Frames: ['Exam', 'Frames', 'Spectacle Lens'],
  'Contact Lens': ['Exam', 'Contact Lens', 'Contact Lens Fit & F/U'],
  'Spectacle Lens': ['Exam', 'Frames', 'Spectacle Lens'],
  'Contact Lens Fit & F/U': ['Exam', 'Contact Lens', 'Contact Lens Fit & F/U'],
}

const getAllowed = (types) => types.reduce((acc, type) => {
  const list = COMPATIBLE[type] || [type]
  return acc ? acc.filter((s) => list.includes(s)) : list
}, null)

function VersantStep1({ eligibilityData = [], actionLabel }) {
  const allowed = getAllowed(eligibilityData.filter((r) => r.active).map((r) => r.service_type))

  return (
    <LogsListing
      logs={eligibilityData}
      TableHead={[{ title: '' }, { title: 'Service', className: 'text-nowrap' }, { title: 'Availability', className: 'text-nowrap' }]}
    >
      {eligibilityData.map((item, i) => (
        <tr key={item.service_type}>
          <td>
            <Field
              name={`eligibility.data[${i}].active`}
              component={Checkbox}
              disabled={item.button_clickable == 'No' || (allowed && !item.active && !allowed.includes(item.service_type))}
              wrapperClasses="pl-4"
            />
          </td>
          <td>{item.service_type}</td>
          <td>{item.availability}</td>
        </tr>
      ))}
      <tr>
        <td colSpan={10}><SpecteraFormButton buttonClasses="py-2" actionLabel={actionLabel} /></td>
      </tr>
    </LogsListing>
  )
}

export default connect((state) => ({ eligibilityData: selector(state, 'eligibility.data') || [] }))(VersantStep1)
